export default "__VITE_ASSET__ww1R_nXr__"